<template>
  <div>
    <div class="akd-form">
      <div class="modal-body">
        <base-input
          v-model="formItems.name"
          :id="'akd-input-1'"
          inputType="text"
          labelText="Adı"
          :class="{ 'is-invalid': submitted && $v.formItems.name.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.name.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.depth"
          inputType="number"
          labelText="Derinlik"
          id="nadepthe"
          name="depth"
          class="form-control"
          :class="{ 'is-invalid': submitted && $v.formItems.depth.$error }"
        />
        <base-input
          v-model="formItems.shortContent"
          :id="'akd-input-2'"
          inputType="text"
          labelText="Kısa Tanım"
        />
        <base-input
          v-model="formItems.description"
          :id="'akd-input-3'"
          inputType="text"
          labelText="Açıklama"
        />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button @click="sendForm" class="add"> Kaydet </base-button>
      </div>
    </div>
  </div>
</template>
<script>
import { minValue, numeric, required } from "vuelidate/lib/validators";
import { BaseInput, BaseButton } from "@/components";

export default {
  name: "AkdDefinitionForm",
  data() {
    return {
      clickedNewBtn: this.clickedNewItemBtn,
      formItems: {
        id: this.selectedDataId,
        name: this.selectedDataName,
        depth: this.selectedDataDepth,
        shortContent: this.selectedShortContent,
        description: this.selectedDescription,
        order: this.selectedDataOrder,
      },
      submitted: false,
      invalidMessage: "Bu alan boş bırakılamaz!",
    };
  },
  validations: {
    formItems: {
      name: { required },
      depth: { required, numeric, minValue: minValue(0) },
    },
  },
  components: {
    BaseInput,
    BaseButton,
  },
  methods: {
    sendForm() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
      }
      this.formItems.depth = Number(this.formItems.depth);
      this.$emit("submit-form", this.formItems);
    },
  },
  props: {
    clickedNewItemBtn: Boolean,
    id: Number,
    selectedDataId: Number,
    selectedDataName: String,
    selectedDataDepth: Number,
    selectedShortContent: String,
    selectedDescription: String,
    shortContent: String,
    description: String,
    selectedDataOrder: Number,
    InsertUpdateForm: {
      type: Function,
    },
  },
};
</script>
<style lang="scss">
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
</style>
